import { render, staticRenderFns } from "./Finantial.vue?vue&type=template&id=165b92e5&scoped=true&"
import script from "./Finantial.vue?vue&type=script&lang=js&"
export * from "./Finantial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165b92e5",
  null
  
)

export default component.exports